import { Fragment, useContext, useEffect, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createQueryStringFromFilters,
  sendApiRequest,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import Filters from "../../components/Header/Filters";
import { Alert, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";
import AuthModuleFlowsEconTable from "../../components/Tables/AuthModuleFlowsEconTable";

const AuthModuleFlowsEcon = () => {
  const [flows, setFlows] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const getFilters = (filters) => {
    setFilters(filters);
  };

  useEffect(() => {
    if (filters !== null) {
      setTimeout(() => {
        getFlows();
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const getFlows = () => {
    setIsLoading(true);
    setError(null);
    setTimeout(() => {
      sendApiRequest(
        "StagedFlows/GetAllStagedFlowsForEconApproval",
        "GET",
        true,
        filters,
        signIn,
        signOut,
        navigate,
        createQueryStringFromFilters,
        userContext,
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setError(null);
            setFlows(response.data.stagedFlowsForEconApproval);
            setIsLoading(false);
          }
        }
      });
    }, 500);
  };

  return (
    <Fragment>
      <Filters page="authModuleFlowsEcon" getFilters={getFilters} />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <AuthModuleFlowsEconTable
            items={flows}
            columns={[
              {
                name: "Data acquisizione",
                type: "date",
                sortable: true,
                value: "predispositionDate",
              },
              {
                name: "Nome Del Flusso",
                type: "string",
                sortable: true,
                value: "name",
              },
              {
                name: "Tipologia",
                type: "string",
                sortable: false,
                value: "clientCodeName",
              },
              {
                name: "Formato",
                type: "string",
                sortable: false,
                value: "format",
              },
              {
                name: "Conteggio Notifiche Digitali",
                type: "integer",
                sortable: false,
                value: "digitalNotifCount",
              },
              {
                name: "Costo componente piattaforma",
                type: "bool",
                sortable: false,
                value: "digitalPrice",
              },
              {
                name: "Conteggio Notifiche Analogiche",
                type: "integer",
                sortable: false,
                value: "analogicalNotifCount",
              },
              {
                name: "Costo Totale Notifiche Analogiche",
                type: "bool",
                sortable: false,
                value: "analogicalPrice",
              },
              {
                name: "Costo Totale IVA compresa",
                type: "bool",
                sortable: false,
                value: "analogicalPrice",
              },
              {
                name: "Stato",
                type: "bool",
                sortable: false,
                value: "status",
              },
              {
                name: "",
                type: null,
                sortable: false,
                value: "",
              },
            ]}
            setFlows={setFlows}
            setIsLoading={setIsLoading}
            getFlows={getFlows}
          />
        )}
      </Section>
      <Footer />
    </Fragment>
  );
};

export default AuthModuleFlowsEcon;
